export default "__VITE_ASSET__BIX8BhaI__"